if (!window.jng.context) {
    window.jng.context = {
        _context: {},
        _apiBase: {},
        getApiBase() {
            let key = this._getKey()
            if (this._apiBase[key]) return this._apiBase[key]
            let apiBase =  jng.storage.getLocalStorage('apibase')
            if (apiBase) {
                this._apiBase = apiBase
                return this._apiBase[key]
            }
        },
        removeContext() {
            let key = this._getKey()
            delete this._context[key]
            this.saveContext()
        },
        getContext() {
            let key = this._getKey()
            if (this._context[key]) return this._context[key]
            let allContext =  jng.storage.getLocalStorage('context')
            if (allContext) {
                this._context = allContext
                return this._context[key]
            }
        },
        _justWaitForContext(resolve) {
            let context = this.getContext()  
            if (context) resolve(context)
            else setTimeout(() => {
                this._justWaitForContext(resolve)
            }, 10)
        },
        waitForContext() {
            return new Promise((resolve) => {
                this._justWaitForContext(resolve)
            })
        },
        saveContext() {
            jng.storage.setLocalStorage('context', this._context, 24)
        },
        saveApiBase() {
            jng.storage.setLocalStorage('apibase', this._apiBase, 24 * 30)
        },
        _getKey() {
            let key = window.location.host.replace(':', '__')
            return key
        },
        setApiBase(api) {
            let key = this._getKey()
            this._apiBase[key] = {
                key: key,
                data: {base: api}
            }
            this.saveApiBase()
        },
        createNewContext() {
            let key = this._getKey()
            this._context[key] = {
                key: key,
                data: {}
            }
            this.saveContext()
            return this._context[key]
        }
    }
}
